import * as React from 'react';
import { Bell, SlidersHorizontal } from '@liveauctioneers/hammer-ui-core/icons';
import { Drawer } from '@liveauctioneers/hammer-ui-core/drawer';
import { FormattedMessage, useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { getNotificationsUrl } from '@/utils/urls';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

interface MobileSlideMenuProps {
    preparedSavedSearchFilter: React.ReactElement;
}

const MobileSlideMenu = ({ preparedSavedSearchFilter }: MobileSlideMenuProps) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const { formatMessage } = useIntl();
    const navigate = useNavigate();
    const manageUrl = getNotificationsUrl('searches');

    return (
        <>
            <InlineButton
                icon={SlidersHorizontal}
                onClick={() => setIsDrawerOpen(true)}
            >
                <FormattedMessage id="search_alerts.sortAndSettings" />
            </InlineButton>
            <Drawer
                actions={
                    <SubtleMonochromeLink
                        data-testid="manageNotifications"
                        href={manageUrl}
                        onClick={(e) => {
                            e.preventDefault();
                            setIsDrawerOpen(false);
                            window.requestAnimationFrame(() => {
                                navigate(manageUrl);
                            });
                        }}
                    >
                        <InlineButton icon={Bell}>
                            <FormattedMessage id="manageNotifications" />
                        </InlineButton>
                    </SubtleMonochromeLink>
                }
                anchor="right"
                closeOnOutsideClick
                density="comfortable"
                handleClose={() => setIsDrawerOpen(false)}
                hasShadow
                headerText={formatMessage({ id: 'search_alerts.sortAndSettings' })}
                show={isDrawerOpen}
                size="narrow"
            >
                {preparedSavedSearchFilter}
            </Drawer>
        </>
    );
};

export default MobileSlideMenu;
